// extracted by mini-css-extract-plugin
module.exports = {"InputError":"style_InputError__23ftu","wrapper":"style_wrapper__kBWU5","error":"style_error__3LLzI"};